import React, {Component} from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';

import WallMateriaItem from "components/wall/WallMaterialItem";
import 'sass/list/WallMaterialList.scss';

class WallMaterialList extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {
        let {wallMaterials, responsiveGrid = false, ...restProps} = this.props;

        let mapFn = function(wallMaterial, index) {
            return <WallMateriaItem wallMaterial={wallMaterial} {...restProps} key={wallMaterial.id}/>;
        };
        let className = 'wall-material-list';

        if (responsiveGrid) {
            mapFn = function(wallMaterial, index) {
                return <div key={wallMaterial.id}><WallMateriaItem wallMaterial={wallMaterial} {...restProps} /></div>;
            };

            className += ' ui-responsive-grid';
            if (responsiveGrid === 'single-row') {
                className += ' single-row';
            }
        }

        return (
            <div className={className}>
                {wallMaterials.map(mapFn)}
            </div>
        )
    }
}

WallMaterialList.propTypes = {
    wallMaterials: PropTypes.array,
    showAuthor: PropTypes.bool,
    showDate: PropTypes.bool,
    showStats: PropTypes.bool,
    responsiveGrid: PropTypes.any
};

export default connect(state => ({ currentUser: state.currentUser }))(WallMaterialList)





// WEBPACK FOOTER //
// ./src/components/list/WallMaterialList.js